import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var ResetIcon = ZepIcon_default((props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_166_22)", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.254 3.74a1 1 0 0 0-1.225.707L4.931 8.545A1 1 0 0 0 5.64 9.77l4.098 1.098a1 1 0 1 0 .517-1.932l-1.766-.473 1.373-.793c3.073-1.774 7.106-.693 8.88 2.38 1.774 3.071.693 7.104-2.38 8.878-3.072 1.774-7.105.694-8.879-2.379a1 1 0 0 0-1.732 1c2.326 4.03 7.582 5.438 11.611 3.111 4.03-2.326 5.438-7.582 3.112-11.61C18.147 5.02 12.89 3.611 8.86 5.937l-1.373.793.473-1.766a1 1 0 0 0-.707-1.225Z",
      fill: props.fill || "currentColor"
    }
  ) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_166_22", children: /* @__PURE__ */ jsx("path", { fill: props.fill || "currentColor", d: "M0 0h24v24H0z" }) }) })
] }));

export { ResetIcon };
